import Button from 'components/formElements/Button'
import { PropTypes } from 'prop-types'
import {useSelector} from 'react-redux'

const ApprovalContent = ({handleClose, handleApproved}) => {
    const {approvalModal} = useSelector(state => state.general)
  return (
    <div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
        <div className="row text-center">
            <div className="col-12">
            {approvalModal.content}
            </div>
        </div>
        <div className="row justify-content-center gap-3">
            <Button handleClick={handleApproved} disabled={approvalModal?.loading} className='btn-success' title={'Onayla'} />
            <Button handleClick={handleClose} className='btn-danger-outline' title={'Vazgeç'} />
        </div>
    </div>
  )
}
ApprovalContent.propTypes = {
  handleClose: PropTypes.func,
  handleApproved: PropTypes.func
}
export default ApprovalContent